import { Component, EventEmitter, Input, OnChanges, OnInit, Output, Self, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { ApiServiceBase } from 'src/app/Services/api.service.base';

@Component({
    selector: 'app-carcounter-selector',
    templateUrl: './carcounter-selector.component.html',
    styleUrls: ['./carcounter-selector.component.scss'],
    standalone: false
})
export class CarCounterSelectorComponent implements OnInit, ControlValueAccessor, OnChanges {

  public carcounterChipId: string | null = null;
  @Output()
  public carcounterIdChange = new EventEmitter<string | null>();

  public InitChipId = "";
  @Input()
  public CarCounter: any = {};

  public searchResults: any[] = [];
  public searchTerm: string = "ChipId";
  public isLoading = false;

  constructor(private apiService: ApiServiceBase, @Self() public ngControl: NgControl) {
    if (ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.carcounterChipId = this.CarCounter.ChipId;
    this.onChange(this.CarCounter.ChipId);
    this.carcounterIdChange.emit(this.CarCounter);
  }

  public writeValue(id: string | null): void {
    console.log("Write value");

    this.carcounterChipId = id;
    this.CarCounter.ChipId = id;
    if (this.carcounterChipId == "") this.CarCounter = null;
  }
  public onChange = (id: string | null) => {
    this.carcounterIdChange.emit(id);
   };
   
  public registerOnChange(fn: any): void {
    console.log("Reg on change");

    this.onChange = fn;
  }
  public onTouched = () => { };
  public registerOnTouched(fn: any): void {
    console.log("On Touched");

    this.onTouched = fn;
  }
  ngOnInit(): void {
  }


  public ItemSelected(item: any) {
    if (item && item != null && item.Id) {
      this.CarCounter = { Id: item.Id, ChipId: item.ChipId, OrganizationId: item.OrganizationId };
      this.carcounterChipId = item.ChipId;
      this.onChange(item.ChipId);
      this.carcounterIdChange.emit(this.CarCounter);
    }
  }
  public SearchChanged(val: string) {
    console.log("Car Counter Selector search event: '" + val + "'");
    if (val == null || val == "") return;
    this.CarCounter = null;
    this.isLoading = true;
    //"infrastructure/sensor/searches"
    this.apiService.Post<any>("hardware/carcounters/searches", { PageNumber: 1, PageSize: 8, SearchTerm: val }).then(result => {
      this.searchResults = [];
      result.Results.forEach((element: any) => {
        this.searchResults.push({
          ChipId: element.ChipId.toString(),
          Id: element.Id,
          OrganizationId: element.OrganizationId
        });
      });

      console.log("Search results: ");

      console.log(this.searchResults);

      this.isLoading = false;
    });
  }
  public ClearCarCounter() {
    this.carcounterChipId = null;
    this.onChange(null);
  }

  public Cleared() {
    this.carcounterChipId = null;
    this.onChange(null);
  }
  public KeyPress(evt: any) {
    if (evt.keyCode == 13) {
      evt.stopPropagation();
    }
  }
  public InputKeyPress(evt: any) {

  }

}
